import React from 'react';
import { Dialog, Box, IconButton, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BillingAndInvoiceProvider } from '../../contexts/BillingAndInvoiceContext';
import UpgradeToProPage from './UpgradeToProPage';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const grainSvg =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.6' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)' opacity='.08' fill='%23d1d5db'/%3E%3C/svg%3E\")";

export default function UpgradeToProModal({ open, onClose }) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={(e, reason) => {
        if (reason !== 'backdropClick') onClose();
      }}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          bgcolor: '#f8fafc',
          backgroundImage: grainSvg,
        },
      }}
    >
      {/* Top bar */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          height: 60,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          bgcolor: 'rgba(248,250,252,0.9)',
          backdropFilter: 'blur(6px)',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
        }}
      >
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Body */}
      <Box sx={{ height: 'calc(100vh - 60px)', overflow: 'auto' }}>
        <BillingAndInvoiceProvider>
          <UpgradeToProPage isModal onClose={onClose} />
        </BillingAndInvoiceProvider>
      </Box>
    </Dialog>
  );
}
